import { Box, Grid, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from "@mui/material";
import { theme } from "../../common/style/Theme";
import { DoubleArrow } from "@mui/icons-material";

const Disclaimer = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

    const sections = [
        {
            title: "1. General Information Disclaimer",
            paragraphs: [
                "All content available on this website is provided in good faith and for general information purposes only.",
                "While M5 Info Solutions Private Limited strives to keep information accurate and up to date, we make no warranties or representations of any kind, express or implied, regarding:",
            ],
            bullets: [
                "Completeness",
                "Accuracy",
                "Reliability",
                "Suitability",
                "Availability of information, products, services, or related graphics contained on the website",
            ],
            footer: "Any reliance you place on such information is strictly at your own risk.",
        },
        {
            title: "2. Professional Advice Disclaimer",
            paragraphs: [
                "The information on this website does not constitute professional, technical, financial, legal, or business advice.",
                "Users should seek appropriate professional consultation before making decisions based on information available on this website.",
                "M5 Info Solutions Private Limited shall not be responsible for actions taken based on the content provided on this website.",
            ],
        },
        {
            title: "3. Technology and Software Disclaimer",
            content: "Descriptions of software products, digital platforms, or technology solutions presented on this website are for informational purposes only.",
            afterContent: "Actual features, capabilities, performance, and availability may vary based on:",
            bullets: [
                "Project requirements",
                "Technical configurations",
                "Client agreements",
                "Platform updates",
            ],
            footer: "The company reserves the right to modify or update product offerings at any time without prior notice.",
        },
        {
            title: "4. External Links Disclaimer",
            content: "This website may contain links to external websites or resources that are not owned or controlled by M5 Info Solutions Private Limited.",
            afterContent: "We do not guarantee the accuracy, relevance, or completeness of information on such external websites. M5 Info Solutions Private Limited is not responsible for:",
            bullets: [
                "The content of external websites",
                "Their privacy practices",
                "Their services or products",
            ],
            footer: "Users access external links at their own discretion.",
        },
        {
            title: "5. Limitation of Liability",
            content: "Under no circumstances shall M5 Info Solutions Private Limited, its directors, employees, partners, or affiliates be liable for any loss or damage including, without limitation:",
            bullets: [
                "Indirect or consequential loss",
                "Data loss",
                "Business interruption",
                "Loss of profits",
            ],
            footer: "arising out of or in connection with the use of this website.",
        },
        {
            title: "6. Website Availability",
            content: "We strive to ensure that the website operates smoothly. However, M5 Info Solutions Private Limited takes no responsibility for temporary unavailability of the website due to technical issues beyond our control.",
        },
        {
            title: "7. Intellectual Property Notice",
            paragraphs: [
                "All logos, trademarks, content, graphics, and materials displayed on this website are the property of M5 Info Solutions Private Limited unless otherwise stated.",
                "Unauthorized use, reproduction, or distribution of any materials from this website without written permission is strictly prohibited.",
            ],
        },
        {
            title: "8. Changes to This Disclaimer",
            content: "M5 Info Solutions Private Limited reserves the right to modify or update this Disclaimer at any time without prior notice. Changes will be effective immediately upon posting on this page.",
        },
        {
            title: "9. Contact Information",
            content: "For any questions regarding this Disclaimer, please contact:",
            subContent: "M5 Info Solutions Private Limited\nBengaluru, Karnataka\nIndia",
            afterContent: "Email: info@m5infosolutions.com\nWebsite: www.m5infosolutions.com",
        },
    ];

    return (
        <Box>
            {/* Hero Section */}
            <Box style={{
                width: "100vw",
                height: isMobile ? "50vh" : "45vh",
                position: "relative",
                background: `linear-gradient(135deg, ${theme.palette.common.black}, ${theme.palette.primary.main})`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Box style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `repeating-linear-gradient(
                        45deg,
                        transparent,
                        transparent 2px,
                        rgba(255,255,255,0.03) 2px,
                        rgba(255,255,255,0.03) 4px
                    )`,
                    zIndex: 0,
                }} />
                <Box style={{
                    position: "relative",
                    zIndex: 1,
                    textAlign: "center",
                    padding: isMobile ? "0 5vw" : "0 10vw",
                }}>
                    <Typography variant={isMobile ? "h3" : "h1"} style={{
                        color: theme.palette.common.white,
                        fontWeight: 800,
                        marginBottom: "15px",
                        fontSize: isMobile ? "2rem" : isTablet ? "2.8rem" : "3.8rem",
                    }}>
                        Website Disclaimer
                    </Typography>
                    <Typography variant="body1" style={{
                        color: theme.palette.common.white,
                        opacity: 0.8,
                        maxWidth: "700px",
                        margin: "0 auto",
                        lineHeight: "1.7",
                    }}>
                        Important information about the use and limitations of our website content.
                    </Typography>
                </Box>
            </Box>

            {/* Effective Date & Intro */}
            <Grid container style={{
                padding: isMobile ? "8vw 5vw 4vw 5vw" : isTablet ? "5vw 8vw 3vw 8vw" : "4vw 15vw 2vw 15vw",
            }}>
                <Grid size={{ xs: 12 }}>
                    <Box style={{
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                        padding: isMobile ? "20px 25px" : "25px 35px",
                        borderRadius: "12px",
                        marginBottom: "30px",
                    }}>
                        <Typography variant="h6" style={{
                            color: theme.palette.common.white,
                            fontWeight: 600,
                        }}>
                            Effective Date: January 1, 2026
                        </Typography>
                    </Box>
                    <Typography variant="body1" style={{
                        lineHeight: "1.8",
                        marginBottom: "15px",
                    }}>
                        The information provided on www.m5infosolutions.com is published by M5 Info Solutions Private Limited ("Company", "M5", "we", "our", or "us") for general informational purposes only.
                    </Typography>
                    <Typography variant="body1" style={{
                        lineHeight: "1.8",
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                    }}>
                        By using this website, you agree to the terms of this disclaimer.
                    </Typography>
                </Grid>
            </Grid>

            {/* Sections */}
            <Grid container style={{
                padding: isMobile ? "0 5vw 8vw 5vw" : isTablet ? "0 8vw 5vw 8vw" : "0 15vw 5vw 15vw",
            }}>
                <Grid size={{ xs: 12 }}>
                    {sections.map((section, idx) => (
                        <Box key={idx} style={{
                            marginBottom: "35px",
                            padding: isMobile ? "25px 20px" : "30px 35px",
                            background: idx % 2 === 0 ? theme.palette.background.paper : theme.palette.common.white,
                            borderRadius: "12px",
                            borderLeft: `4px solid ${idx % 2 === 0 ? theme.palette.primary.main : theme.palette.secondary.main}`,
                            boxShadow: "rgba(17, 12, 46, 0.08) 0px 8px 40px 0px",
                        }}>
                            <Typography variant="h5" style={{
                                fontWeight: 700,
                                color: theme.palette.primary.main,
                                marginBottom: "15px",
                                fontSize: isMobile ? "1.15rem" : "1.25rem",
                            }}>
                                {section.title}
                            </Typography>

                            {section.paragraphs && section.paragraphs.map((p, pIdx) => (
                                <Typography key={pIdx} variant="body1" style={{
                                    lineHeight: "1.8",
                                    marginBottom: "12px",
                                }}>
                                    {p}
                                </Typography>
                            ))}

                            {section.content && (
                                <Typography variant="body1" style={{
                                    lineHeight: "1.8",
                                    marginBottom: "12px",
                                }}>
                                    {section.content}
                                </Typography>
                            )}

                            {section.subContent && (
                                <Box style={{
                                    background: `${theme.palette.primary.light}30`,
                                    padding: "15px 20px",
                                    borderRadius: "8px",
                                    marginBottom: "15px",
                                }}>
                                    <Typography variant="body1" style={{
                                        fontWeight: 600,
                                        whiteSpace: "pre-line",
                                        lineHeight: "1.8",
                                    }}>
                                        {section.subContent}
                                    </Typography>
                                </Box>
                            )}

                            {section.afterContent && (
                                <Typography variant="body1" style={{
                                    lineHeight: "1.8",
                                    marginBottom: "8px",
                                    whiteSpace: "pre-line",
                                }}>
                                    {section.afterContent}
                                </Typography>
                            )}

                            {section.bullets && (
                                <List style={{ padding: "0 0 0 5px" }}>
                                    {section.bullets.map((bullet, bIdx) => (
                                        <ListItem key={bIdx} style={{ padding: "3px 0" }}>
                                            <ListItemIcon style={{ minWidth: "35px" }}>
                                                <DoubleArrow style={{
                                                    color: theme.palette.secondary.main,
                                                    fontSize: "1.1rem",
                                                }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={bullet}
                                                primaryTypographyProps={{
                                                    style: { lineHeight: "1.7" }
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            )}

                            {section.footer && (
                                <Typography variant="body1" style={{
                                    lineHeight: "1.8",
                                    marginTop: "10px",
                                    fontWeight: 500,
                                    color: theme.palette.text.primary,
                                }}>
                                    {section.footer}
                                </Typography>
                            )}
                        </Box>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default Disclaimer;
